const MOBILE_MAX_WIDTH = 749;

function isMobileViewport() {
  return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
}

function getInitialVisibleCount($container) {
  const desktopCount = parseInt($container.data('initial-visible'), 10);
  const mobileCount = parseInt($container.data('initial-visible-mobile'), 10);
  const fallback = isMobileViewport() ? 4 : 6;
  const count = isMobileViewport() ? mobileCount : desktopCount;

  return Number.isFinite(count) && count > 0 ? count : fallback;
}

function initColorOptions() {
  const $colorOptionContainers = $('.color-options-container');

  $colorOptionContainers.each(function() {
    const $container = $(this);
    const visibleCount = getInitialVisibleCount($container);
    const $moreButtonContainer = $container.find('.color-options-more-container');
    const $moreButton = $moreButtonContainer.find('.color-options-more');
    const $customOptions = $container.find('.option-item:not(.color-options-more-container):not(:has(input[name="Color"][value*="(In Stock)"])');
    let exploreMore = false;

    $customOptions.show();
    $moreButton.off('click').removeClass('expanded').text('Show More');

    if ($customOptions.length > visibleCount) {
      $customOptions.slice(visibleCount).hide();

      if ($moreButtonContainer.length) {
        $moreButtonContainer.show();
        $moreButton.on('click', () => {
          exploreMore = !exploreMore;

          if (exploreMore) {
            $moreButton.text('Show Less');
            $customOptions.show();
            $moreButton.addClass('expanded');
          } else {
            $moreButton.text('Show More');
            $customOptions.slice(visibleCount).hide();
            $moreButtonContainer.show();
            $moreButton.removeClass('expanded');
          }
        });
      }
    } else if ($moreButtonContainer.length) {
      $moreButtonContainer.hide();
    }

    $container.css('display', 'grid');
  });
}

function bindColorOptionsResize() {
  const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
  const handleViewportChange = () => initColorOptions();

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', handleViewportChange);
  } else {
    mediaQuery.addListener(handleViewportChange);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initColorOptions();
    bindColorOptionsResize();
  });
} else {
  initColorOptions();
  bindColorOptionsResize();
}
